import App from './App'

export default App



// WEBPACK FOOTER //
// ./src/containers/App/index.js